// Checkout-local bilingual dictionary (English / Kreyòl Ayisyen).
// Independent from the site-wide language: selecting MonCash/NatCash auto-switches
// checkout to Kreyòl, Stripe stays English, and the buyer can override manually.
export const CHECKOUT = {
    en: {
        select_method: "Select Payment Method",
        card_label: "Stripe",
        card_sub: "Visa · Mastercard",
        mobile_sub: "Haiti mobile money",
        complete_purchase: "Complete Your Purchase",
        full_name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        ticket_type: "Ticket Type",
        qty: "Quantity",
        total: "Total Amount",
        continue_card: "Continue to secure payment",
        get_free: "Get my free tickets",
        select_first: "Select a ticket first",
        secure_note: "Secure card payment — your ticket arrives by email",
        free_note: "Free tickets — no payment needed, QR arrives by email",
        mm_note: "Manual transfer — your ticket is emailed only after the LAKOU team verifies your payment",
        processing_note: "Card processing included — nothing more at checkout",
        send_payment: "Send Payment",
        tx_ref: "Transaction Reference",
        submit_payment: "Submit Payment",
        pending: "Pending Verification",
        approved: "Payment Approved",
        rejected: "Payment Rejected",
        sender_ph: "Phone number you sent the money from",
        txid_ph: "Transaction reference number (if you have it)",
        attach: "Attach transfer screenshot",
        attached: "Screenshot attached",
        new_order: "Start a new order",
        step_send: "Step 1 — Send the money first",
        step_confirm: "Step 2 — Confirm your payment",
        send_to: "Send to",
        instructions_title: "PAY WITH MONCASH OR NATCASH",
        instructions: [
            "Send the amount shown on screen to the LAKOU MonCash or NatCash number.",
            "Double-check the number before sending the money.",
            "After paying, enter the transaction reference number.",
            "Click the \"Submit Payment\" button.",
            "The LAKOU team will verify that the money arrived.",
            "Once we confirm your payment, you will automatically receive your ticket with your QR code by email.",
        ],
        instructions_important: "IMPORTANT: No ticket is valid until the LAKOU team has verified your payment.",
        done_title: "THANK YOU FOR CHOOSING LAKOU!",
        done_body: "We received your payment verification request. The LAKOU team will verify the transaction. Once payment is confirmed, you will receive your official ticket by email.",
        done_event: "LAKOU — THE EXPERIENCE · December 12, 2026 | Léogâne, Haiti",
        err_checkout: "Could not start checkout. Please try again.",
        err_upload: "Upload failed",
        copied: "Copied",
    },
    ht: {
        select_method: "Chwazi fason w ap peye a",
        card_label: "Stripe",
        card_sub: "Visa · Mastercard",
        mobile_sub: "Lajan mobil Ayiti",
        complete_purchase: "Finalize acha w la",
        full_name: "Non konplè",
        email: "Adrès imèl",
        phone: "Nimewo telefòn",
        ticket_type: "Kalite tikè",
        qty: "Kantite",
        total: "Montan total",
        continue_card: "Kontinye nan peman sekirize a",
        get_free: "Pran tikè gratis mwen",
        select_first: "Chwazi yon tikè anvan",
        secure_note: "Peman kat sekirize — tikè ou a rive nan imèl ou",
        free_note: "Tikè gratis — pèpèm peman, kòd QR la rive nan imèl ou",
        mm_note: "Transfè manyèl — tikè ou a voye nan imèl sèlman apre ekip LAKOU a verifye peman an",
        processing_note: "Frè kat la ladan l — pa gen anyen ankò pou peye",
        send_payment: "Voye peman an",
        tx_ref: "Nimewo referans tranzaksyon an",
        submit_payment: "Soumèt peman an",
        pending: "Ann tann verifikasyon peman an",
        approved: "Peman an konfime",
        rejected: "Peman an pa valide",
        sender_ph: "Nimewo telefòn ou te voye lajan an ak",
        txid_ph: "Nimewo referans tranzaksyon an (si w genyen)",
        attach: "Tachke kaptire ekran peman an",
        attached: "Kaptire ekran an tachke",
        new_order: "Kòmanse yon nouvo lòd",
        step_send: "Etap 1 — Voye lajan an an premye",
        step_confirm: "Etap 2 — Konfime peman ou a",
        send_to: "Voye l sou",
        instructions_title: "PEYE AK MONCASH OSWA NATCASH",
        instructions: [
            "Voye montan ki parèt sou ekran an sou nimewo MonCash oswa NatCash LAKOU a.",
            "Verifye nimewo a byen anvan ou voye lajan an.",
            "Apre ou fin peye, antre nimewo referans tranzaksyon an.",
            "Klike sou bouton \"Soumèt Peman an.\"",
            "Ekip LAKOU a ap verifye si lajan an antre.",
            "Depi nou konfime peman an, w ap resevwa tikè w la otomatikman nan imèl ou ansanm ak kòd QR ou a.",
        ],
        instructions_important: "ENPÒTAN: Pa gen okenn tikè k ap valide toutotan ekip LAKOU a poko verifye peman an.",
        done_title: "MÈSI PASKE W CHWAZI LAKOU! 🌍",
        done_body: "Nou resevwa demann verifikasyon peman w lan. Ekip LAKOU a pral verifye tranzaksyon an. Depi peman an konfime, w ap resevwa tikè ofisyèl ou a nan imèl ou.",
        done_event: "LAKOU — THE EXPERIENCE · 12 Desanm 2026 | Leyogàn, Ayiti",
        err_checkout: "Nou pa t ka kòmanse peman an. Tanpri eseye ankò.",
        err_upload: "Voye fichye a pa mache",
        copied: "Kopye",
    },
};

export const ct = (lang, key) => CHECKOUT[lang]?.[key] ?? CHECKOUT.en[key] ?? key;
